export default "__VITE_ASSET__CMsFqxgB__"